module.exports = __webpack_public_path__ + "img/VsLotion3.f927e07c.jpg";